import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { ASSETS_TYPOGRAPHY_FEATURE_GROUP } from './group';

export const ASSETS_TYPOGRAPHY_FEATURES = {
  CREATE: {
    guid: 'e7b3c920-1f5d-4a86-c974-2a8b3d6e0000',
    name: 'assets:typography:create',
    description: 'Upload custom fonts to the asset library',
    action: 'create',
    product: 'account',
    parentGuid: ASSETS_TYPOGRAPHY_FEATURE_GROUP.guid,
  },
  READ: {
    guid: 'e7b3c920-1f5d-4a86-c974-2a8b3d6e0001',
    name: 'assets:typography:read',
    description: 'View typography settings and custom fonts',
    action: 'read',
    product: 'account',
    parentGuid: ASSETS_TYPOGRAPHY_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'e7b3c920-1f5d-4a86-c974-2a8b3d6e0002',
    name: 'assets:typography:update',
    description: 'Edit font family, size, and typography settings',
    action: 'update',
    product: 'account',
    parentGuid: ASSETS_TYPOGRAPHY_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'e7b3c920-1f5d-4a86-c974-2a8b3d6e0003',
    name: 'assets:typography:delete',
    description: 'Remove custom fonts from the asset library',
    action: 'delete',
    product: 'account',
    parentGuid: ASSETS_TYPOGRAPHY_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ASSETS_TYPOGRAPHY_FEATURE_GROUP } from './group';

export const ASSETS_TYPOGRAPHY_MODULE: FeatureModule = {
  product: 'account',
  groups: [ASSETS_TYPOGRAPHY_FEATURE_GROUP],
  features: featureList(ASSETS_TYPOGRAPHY_FEATURES),
};
